/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ModifyOtherSystemSourceInput
 */
export interface ModifyOtherSystemSourceInput {
    /**
     * 
     * @type {string}
     * @memberof ModifyOtherSystemSourceInput
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof ModifyOtherSystemSourceInput
     */
    category?: string;
    /**
     * 
     * @type {string}
     * @memberof ModifyOtherSystemSourceInput
     */
    domainId?: string;
    /**
     * 
     * @type {string}
     * @memberof ModifyOtherSystemSourceInput
     */
    centreId?: string;
}

/**
 * Check if a given object implements the ModifyOtherSystemSourceInput interface.
 */
export function instanceOfModifyOtherSystemSourceInput(value: object): value is ModifyOtherSystemSourceInput {
    return true;
}

export function ModifyOtherSystemSourceInputFromJSON(json: any): ModifyOtherSystemSourceInput {
    return ModifyOtherSystemSourceInputFromJSONTyped(json, false);
}

export function ModifyOtherSystemSourceInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): ModifyOtherSystemSourceInput {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'category': json['category'] == null ? undefined : json['category'],
        'domainId': json['domainId'] == null ? undefined : json['domainId'],
        'centreId': json['centreId'] == null ? undefined : json['centreId'],
    };
}

export function ModifyOtherSystemSourceInputToJSON(json: any): ModifyOtherSystemSourceInput {
    return ModifyOtherSystemSourceInputToJSONTyped(json, false);
}

export function ModifyOtherSystemSourceInputToJSONTyped(value?: ModifyOtherSystemSourceInput | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'category': value['category'],
        'domainId': value['domainId'],
        'centreId': value['centreId'],
    };
}

